module.exports = __webpack_public_path__ + "img/utensils.0d22ffe3.svg";